import { initContract } from '@ts-rest/core'
import { discountsContract } from './discount.contract'
import { pricingContract } from './pricing.contract'
import { promotionsContract } from './promotion.contract'

const c = initContract()

export const pricingServiceContract = c.router(
  {
    pricing: pricingContract,
    discounts: discountsContract,
    promotions: promotionsContract,
  },
)
